<template>
  <div class="home">

  </div>
</template>

<script>
export default {
  name: 'home'
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Home.vue